import React from 'react'
import {Flex} from '/app/src/component'
import MenuSubTitle from '/app/src/component/Menu/SubTitle';
import MenuSubItem  from '/app/src/component/Menu/SubItem';

class CompanySettings extends React.Component {
    render(){
        return (
            <Flex column grow>
                <MenuSubTitle
                    svgSrc='/images/Menu_CompanySettings.svg'
                    onClick={this.props.onClick}
                    text='Företagsinställningar'
                    svgfill='#c6c6c6'/>
                <Flex column overflowY='auto'>
                    <MenuSubItem
                        svgSrc='/images/Menu_CompanySettingsEmployees.svg'
                        text='Hantera Medarbetare' to='/companySettings/employee' svgfill='#404040'
                        />
                    <MenuSubItem
                        svgSrc='/images/Menu_CompanySettingsInfo.svg'
                        text='Faktureringsuppgifter' to='/companySettings/payment' svgfill='#404040'
                        />
                    <MenuSubItem
                        svgSrc='/images/Menu_CompanySettingsPayment_L.svg'
                        text='Fakturor' to='/companySettings/invoice' svgfill='#404040'
                        />
                    <MenuSubItem
                        svgSrc='/images/ShootingStar_L.svg'
                        text='Prisplan' to='/companySettings/upgrade' svgfill='#404040'
                        />
                    <MenuSubItem
                        svgSrc='/images/Menu_CompanySettingsInstall.svg'
                        text='Installation' to='/companySettings/installation' svgfill='#404040'
                        />
                </Flex>
            </Flex>
        )
    }
}
export default CompanySettings



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/MainMenu/CompanySettings/index.js